"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  cssAnchorName: true
};
exports.default = exports.cssAnchorName = void 0;

var _preact = require("preact");

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _common = require("@insided/shared/utils/common");

var _TopicClosed = _interopRequireDefault(require("@insided/deprecated-preact-components/topic-list-view/TopicClosed"));

var _phrase = _interopRequireDefault(require("@insided/deprecated-libs/translationsUtils/phrase"));

var _HubAI = require("@insided/shared/modules/HubAI");

var _Replies = _interopRequireDefault(require("../V2/Replies"));

var _Topic = _interopRequireDefault(require("../V2/Topic"));

var _Editor = require("../shared/Editor");

var _ThreadedRepliesWrapper = _interopRequireDefault(require("../ThreadedReplies/ThreadedRepliesWrapper"));

var _Topic2 = _interopRequireDefault(require("../Topic"));

var _classnames = _interopRequireDefault(require("classnames"));

var _PinnedAndBestAnswerSection = _interopRequireDefault(require("./PinnedAndBestAnswerSection"));

var _Post = require("../Post");

Object.keys(_Post).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _Post[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _Post[key];
    }
  });
});

var _utils = require("../utils");

Object.keys(_utils).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _utils[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _utils[key];
    }
  });
});

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var TopicPage = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(TopicPage, _Component);

  var _super = _createSuper(TopicPage);

  function TopicPage(props) {
    var _this$props$bestAnswe, _this$props$bestAnswe2, _this$props$pinnedRep, _this$props$pinnedRep2;

    var _this;

    (0, _classCallCheck2.default)(this, TopicPage);
    _this = _super.call(this, props);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      isEditorOpen: false,
      // Set up initial content for translation context
      initialContent: {
        title: _this.props.topic.title,
        topicContent: _this.props.topic.content,
        bestAnswerText: (_this$props$bestAnswe = (_this$props$bestAnswe2 = _this.props.bestAnswer) === null || _this$props$bestAnswe2 === void 0 ? void 0 : _this$props$bestAnswe2.content) !== null && _this$props$bestAnswe !== void 0 ? _this$props$bestAnswe : null,
        pinnedReplyText: (_this$props$pinnedRep = (_this$props$pinnedRep2 = _this.props.pinnedReply) === null || _this$props$pinnedRep2 === void 0 ? void 0 : _this$props$pinnedRep2.content) !== null && _this$props$pinnedRep !== void 0 ? _this$props$pinnedRep : null,
        replies: _this.props.showThreadedReplies ? _this.props.repliesProps.replies.result : _this.props.repliesProps.replies.map(function (reply) {
          return reply.content;
        })
      }
    });
    _this.handleEditorFocus = _this.handleEditorFocus.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleEditorCancel = _this.handleEditorCancel.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleRepliesUpdated = _this.handleRepliesUpdated.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(TopicPage, [{
    key: "handleEditorFocus",
    value: function handleEditorFocus() {
      var currentUser = this.props.currentUser;
      var isGuest = !currentUser.id;

      if (isGuest) {
        window.dispatchEvent(new CustomEvent('GuestUserAction'));
      } else {
        this.setState({
          isEditorOpen: true
        }, function () {
          var editorElement = document.getElementById('reply-editor');

          if (editorElement) {
            editorElement.scrollIntoView({
              behavior: 'smooth',
              block: 'center'
            });
          }
        });
      }
    }
  }, {
    key: "handleEditorCancel",
    value: function handleEditorCancel() {
      this.setState({
        isEditorOpen: false
      });
    }
  }, {
    key: "handleRepliesUpdated",
    value: function handleRepliesUpdated(replies) {
      this.setState(function (prevState) {
        return {
          initialContent: _objectSpread(_objectSpread({}, prevState.initialContent), {}, {
            replies: replies
          })
        };
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this,
          _this$props$phrases$F,
          _this$props$phrases,
          _this$props$phrases$F2;

      var _this$props = this.props,
          topic = _this$props.topic,
          currentPage = _this$props.currentPage,
          attachmentCdn = _this$props.attachmentCdn,
          authors = _this$props.authors,
          unlimitedEditPermission = _this$props.unlimitedEditPermission,
          _this$props$languageL = _this$props.languageList,
          languageList = _this$props$languageL === void 0 ? [] : _this$props$languageL,
          contentHelpfulnessData = _this$props.contentHelpfulnessData,
          currentUser = _this$props.currentUser,
          disableFileAttachments = _this$props.disableFileAttachments,
          topicContent = _this$props.topicContent,
          repliesProps = _this$props.repliesProps,
          pinnedReply = _this$props.pinnedReply,
          userHasPermissionToReply = _this$props.userHasPermissionToReply,
          showPostActions = _this$props.showPostActions,
          bestAnswer = _this$props.bestAnswer,
          userSubscribed = _this$props.userSubscribed,
          _this$props$showThrea = _this$props.showThreadedReplies,
          showThreadedReplies = _this$props$showThrea === void 0 ? false : _this$props$showThrea;
      var _this$state = this.state,
          isEditorOpen = _this$state.isEditorOpen,
          initialContent = _this$state.initialContent;
      var replies = repliesProps.replies,
          totalReplies = repliesProps.totalReplies,
          currentSort = repliesProps.currentSort,
          canMarkBestAnswer = repliesProps.canMarkBestAnswer;
      var isGuest = !currentUser.id;
      var isTopicClosedForReply = topic.closed;
      var shouldDisplayReplies = !isTopicClosedForReply || (showThreadedReplies ? replies.result.length > 0 : replies.length > 0);
      var showHasNoPermission = !isTopicClosedForReply && !isGuest && !userHasPermissionToReply;
      var hasReplies = totalReplies > 0;
      var showFirstToReplyBanner = !hasReplies && !isTopicClosedForReply && (isGuest || userHasPermissionToReply);
      var hideRepliesHeader = !hasReplies && !isGuest && !userHasPermissionToReply;
      return (0, _preact.h)(_HubAI.OnDemandTranslationProvider, {
        initialContent: initialContent,
        languageList: languageList,
        shouldTranslateOnlyOneReply: false,
        threadedRepliesEnabled: showThreadedReplies
      }, (0, _preact.h)("div", {
        className: "box__content"
      }, showThreadedReplies ? (0, _preact.h)(_Topic2.default, {
        topic: topic,
        authors: authors,
        currentUser: currentUser,
        userSubscribed: userSubscribed,
        topicBodyProps: topicContent,
        unlimitedEditPermission: unlimitedEditPermission,
        disableFileAttachments: disableFileAttachments,
        attachmentCdn: attachmentCdn,
        userHasPermissionToReply: userHasPermissionToReply && !isTopicClosedForReply,
        onReplyClick: !isTopicClosedForReply ? function () {
          return _this2.handleEditorFocus();
        } : undefined,
        showPostActions: showPostActions,
        totalReplyCount: totalReplies,
        bestAnswer: bestAnswer,
        pinnedReply: pinnedReply
      }) : (0, _preact.h)("div", {
        className: "box qa-topic-first-post",
        "data-helper": "class-toggle"
      }, (0, _preact.h)(_Topic.default, (0, _extends2.default)({
        topic: topic,
        currentPage: currentPage,
        attachmentCdn: attachmentCdn,
        authors: authors,
        unlimitedEditPermission: unlimitedEditPermission,
        currentUser: currentUser,
        disableFileAttachments: disableFileAttachments,
        contentHelpfulnessData: contentHelpfulnessData,
        pinnedReply: pinnedReply,
        showPostActions: showPostActions,
        bestAnswer: bestAnswer,
        onEditorClick: function onEditorClick() {
          return _this2.handleEditorFocus();
        },
        userSubscribed: userSubscribed,
        totalReplyCount: totalReplies,
        showReplyEditor: showThreadedReplies && userHasPermissionToReply
      }, topicContent))), isTopicClosedForReply && (0, _preact.h)(_TopicClosed.default, {
        message: (0, _preact.h)(_phrase.default, {
          p: "topic.closed.info_message",
          m: "Forum"
        })
      }), showHasNoPermission && (0, _preact.h)(_TopicClosed.default, {
        message: (0, _preact.h)(_phrase.default, {
          p: "topic.closed.no_permission",
          m: "Forum"
        })
      }), showThreadedReplies && !_common.common.isModuleActive('highlightedBestAnswer') && (0, _preact.h)("div", {
        className: "box__content"
      }, (0, _preact.h)(_PinnedAndBestAnswerSection.default, {
        authors: authors,
        bestAnswer: bestAnswer,
        pinnedReply: pinnedReply
      })), showThreadedReplies && !isTopicClosedForReply && (isGuest || userHasPermissionToReply) && (0, _preact.h)("div", {
        className: "box editor"
      }, (0, _preact.h)(_Editor.Editor, {
        isOpen: isEditorOpen,
        replyId: null,
        parentReplyId: null,
        onFocus: function onFocus() {
          return _this2.handleEditorFocus();
        },
        onCancel: function onCancel() {
          return _this2.handleEditorCancel();
        },
        placeholder: (_this$props$phrases$F = (_this$props$phrases = this.props.phrases) === null || _this$props$phrases === void 0 ? void 0 : (_this$props$phrases$F2 = _this$props$phrases.Forum) === null || _this$props$phrases$F2 === void 0 ? void 0 : _this$props$phrases$F2['threaded.replies.editor.placeholder']) !== null && _this$props$phrases$F !== void 0 ? _this$props$phrases$F : '',
        parentTopicId: Number(topic.id),
        contentType: topic.contentType,
        disableFileAttachments: disableFileAttachments,
        currentUser: currentUser,
        redirect: true
      })), shouldDisplayReplies && (0, _preact.h)("div", {
        className: (0, _classnames.default)({
          box: !showThreadedReplies,
          'topic-replies--no-reply': !hasReplies,
          'topic-replies--hidden': hideRepliesHeader
        })
      }, showThreadedReplies ? (0, _preact.h)(_ThreadedRepliesWrapper.default, {
        type: topic.contentType,
        totalReplies: totalReplies,
        currentSort: currentSort,
        replies: replies,
        authors: authors,
        currentUser: currentUser,
        topic: topic,
        pageSize: 10,
        enableSEOUrls: true,
        canMarkBestAnswer: canMarkBestAnswer,
        attachmentCdn: attachmentCdn,
        unlimitedEditPermission: unlimitedEditPermission,
        disableFileAttachments: disableFileAttachments,
        userHasPermissionToReply: userHasPermissionToReply && !isTopicClosedForReply,
        showPostActions: showPostActions,
        onRepliesUpdated: function onRepliesUpdated(replies) {
          return _this2.handleRepliesUpdated(replies);
        }
      }) : (0, _preact.h)(_Replies.default, (0, _extends2.default)({
        topic: topic,
        currentRepliesPage: currentPage,
        attachmentCdn: attachmentCdn,
        authors: authors,
        bestAnswer: bestAnswer,
        unlimitedEditPermission: unlimitedEditPermission,
        currentUser: currentUser,
        disableFileAttachments: disableFileAttachments,
        showFirstToReplyBanner: showFirstToReplyBanner,
        showPostActions: showPostActions
      }, repliesProps)))));
    }
  }]);
  return TopicPage;
}(_preact.Component);

var _default = (0, _HubAI.withOnDemandTranslationProps)(TopicPage, ['translatedBestAnswerText', 'translatedPinnedReplyText']);

exports.default = _default;
var cssAnchorName = 'topic-view';
exports.cssAnchorName = cssAnchorName;